<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      lockReconnect: false, // 是否真正建立连接
      timeout: 22 * 1000, // 22秒一次心跳
      timeoutObj: null, // 心跳心跳倒计时
      serverTimeoutObj: null, // 心跳倒计时
      timeoutnum: null // 断开 重连倒计时
    }
  },
  created() {
   
    //  初始化方法
   //   this.createWebSocket()
  },
  methods: {
    //  创建websocket连接
    createWebSocket() {
      const that = this
      that.webSocet = null
      that.webSocet = new WebSocket('ws://121.4.218.38:9502')
      that.global.setWs(that.webSocet)
      //  console.log('that.webSocet',that.webSocet);
      if (that.webSocet.readyState === 0 && !that.timeoutnum) {
        that.timer = setInterval(() => {
          if (that.timer_num < 3 && that.webSocet.readyState === 0) {
            that.timer_num++
          } else {
            clearInterval(that.timer)
            that.timer = null
            that.timer_num = 0
            // 只要不成功就连接
            if (that.webSocet.readyState !== 1) {
              that.reconnect()
            }
          }
        }, 1000)
      }
      // 链接成功时
      that.webSocet.onopen = function () {
        // 开启心跳
        that.start()
      }
      // 收到消息时
      that.webSocet.onmessage = (msgInfo) => {
        //  console.log('接收到的消息',msgInfo);
        // that.UP_WEBSOCKETINFO({ data: msgInfo.data, timer: msgInfo.timeStamp })
        // 收到服务器信息，心跳重置
        // that.reset()
      }
      // 连接错误
      that.webSocet.onerror = function () {
        console.log('WebSocket连接发生错误')
        // 重连
        that.reconnect()
      }
      //  监听组件的销毁
      that.$once('hook:beforeDestroy', () => {
        if (that.webSocet.close) {
          that.webSocet.close()
          that.webSocet.onclose = () => {
            console.log('web socket 链接已关闭')
          }
        }
      })
    },
    reconnect() {
      // 重新连接
      const that = this
      if (that.webSocet && that.webSocet.readyState === 1) {
        clearInterval(that.timeoutnum)
        that.timeoutnum = null
        that.timeNum = 0
        return
      }
      if (!that.timeoutnum) {
        that.timeoutnum = setInterval(function () {
          if (that.webSocet && that.webSocet.readyState === 1) {
            clearInterval(that.timeoutnum)
            that.timeoutnum = null
            that.timeNum = 0
            return
          }
          // 新连接
          that.createWebSocket()
          that.timeNum++
          if (that.timeNum >= 3) {
            clearInterval(that.timeoutnum)
            that.timeoutnum = null
            that.timeNum = 0
          }
        }, 1000)
      }
    },
    reset() {
      // 重置心跳
      // 清除时间
      clearTimeout(this.timeoutObj)
      clearTimeout(this.serverTimeoutObj)
      // 重启心跳
      this.start()
    },
    start() {
      // 开启心跳
      const that = this
      that.timeoutObj && clearTimeout(that.timeoutObj)
      that.serverTimeoutObj && clearTimeout(that.serverTimeoutObj)
      that.timeoutObj = setTimeout(function () {
        console.log(that.timeout)
        console.log('xxxxxxxxxxxxx心跳==============')
        // 这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (that.webSocet && that.webSocet.readyState === 1) {
          // 如果连接正常
          that.webSocet.send('{"type":"ping"}')
        } else {
          // 否则重连
          that.reconnect()
        }
      }, that.timeout)
    }
  }
}
</script>

<style>
</style>
